import { AgTechButtonProps, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { Payment } from "@sales/data/invoicing/payments/InvoicePaymentData";
import { usePaymentDataDeletePaymentAction } from "@sales/data/invoicing/payments/InvoicePaymentDataActions";

export type PaymentRemovalButtonProps = AgTechButtonProps & {
    payment: Payment
}

export const PaymentRemovalButton = (props: PaymentRemovalButtonProps) => {
    let paymentRemovalSubmission = usePaymentDataDeletePaymentAction();

    let buttonProps: AgTechButtonProps = {
        text: 'Remove Payment',
        icon: 'fas fa-times',
        action: async e => {
            await e.actions.executeDataAction(paymentRemovalSubmission, {
                submittedEntity: props.payment,
            });
        },
        ...props
    };

    return <AgTechButton {...buttonProps} />
}